import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import * as sdf from '@SDFoundation';

import { getI18n } from '@/utils/i18n';

import styles from './InfoItem.cm.styl';

const cx = classNames.bind(styles);
const i18n = getI18n();
class InfoItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showingAll: false,
    };
    this.valueRef = null;
    this.showMore = () => this.setState({ showingAll: true });
  }

  componentDidMount() {
    if (this.valueRef) {
      const range = document.createRange();
      range.selectNodeContents(this.valueRef);
      const { height: totalHeight } = range.getBoundingClientRect();
      // 40 is the max-height set for the value
      if (totalHeight <= 40) {
        this.setState({ showingAll: true });
      }
    }
  }

  render() {
    const { showingAll } = this.state;
    const { name, value, keepWhiteSpace } = this.props;
    const parseValue = (_value) => {
      if (!_value && value !== 0) {
        return '-';
      }
      // will return truthy, 0
      return _value;
    };
    return (
      <div>
        <div className={classNames(styles.rowName, sdf.bodyTertiary)}>{name}</div>
        <div className={classNames(styles.rowValue, { [styles.whiteSpacePre]: keepWhiteSpace })}>
          <div className={cx({ rowPart: !showingAll })} ref={(ref) => (this.valueRef = ref)}>
            {parseValue(value)}
          </div>
          {!showingAll && (
            <span className={styles.rowMore} onClick={this.showMore}>
              {i18n.t`更多`}
            </span>
          )}
        </div>
      </div>
    );
  }
}

InfoItem.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
};
export default InfoItem;
